import { FR } from './france';

export const WF = FR;
